
import { useTranslation } from 'react-i18next';
import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

export default function AboutSection() {
  const { t } = useTranslation();
  const { isVisible, setElementRef } = useScrollAnimation();

  return (
    <section id="about" className="py-24 bg-white" ref={setElementRef}>
      <div className="container mx-auto px-4">
        <div className={`transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
          <h2 className="text-4xl md:text-5xl font-thin text-center mb-16 text-gray-900">
            Story
          </h2>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
            <div className={`transition-all duration-1000 ease-out ${
              isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-8'
            }`} style={{ transitionDelay: '200ms' }}>
              <div className="relative group">
                <div className="absolute inset-0 bg-gradient-to-r from-amber-400/20 to-amber-600/20 rounded-2xl blur-xl group-hover:blur-2xl transition-all duration-500"></div>
                <img 
                  src="https://static.readdy.ai/image/c38ca4b43662e8df5be3570b092391f1/4b199ee9d68555e5eb82b55e49ca6660.png"
                  alt="クリエティブチームのコラボレーション"
                  className="relative rounded-2xl shadow-2xl object-cover w-full h-[250px] sm:h-[300px] md:h-[350px] lg:h-[400px] xl:h-[450px] group-hover:scale-105 transition-all duration-700"
                />
              </div>
            </div>

            <div className="grid grid-cols-1 gap-8">
              <div className="bg-stone-50 rounded-2xl p-8 hover:shadow-lg transition-all duration-300">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-amber-100 rounded-xl flex-shrink-0">
                    <i className="ri-shirt-line text-2xl text-amber-600"></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-stone-800 mb-3">
                      {t('aboutStory.item1.title')}
                    </h3>
                    <p className="text-stone-600 leading-relaxed">
                      {t('aboutStory.item1.description')}
                    </p>
                  </div>
                </div>
              </div>

              <div className="bg-stone-50 rounded-2xl p-8 hover:shadow-lg transition-all duration-300">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-amber-100 rounded-xl flex-shrink-0">
                    <i className="ri-leaf-line text-2xl text-amber-600"></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-stone-800 mb-3">
                      {t('aboutStory.item2.title')}
                    </h3>
                    <p className="text-stone-600 leading-relaxed">
                      {t('aboutStory.item2.description')}
                    </p>
                  </div>
                </div>
              </div>
            </div>

          </div>

        </div>
      </div>
    </section>
  );
}
